import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import SingleTestimonialTwo from '../../components/Testimonial/SingleTestimonialTwo';
import PrevArrowSVG from '../../components/SVG';
import NextArrowSVG from '../../components/SVG/NextArrowSVG';

import avatarImg1 from '../../assets/img/testimonial/avatar-4.png';

const Testimonial = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '3',
    spaceBetween: 35,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev-2',
      nextEl: '.slider-next-2',
    },
  };

  return (
    <div
      id="it-testimonial"
      className="it-testimonial-area it-testimonial-style-2 fix pt-150 pb-150"
    >
      <div className="container">
        <div className="it-testimonial-title-wrap mb-70">
          <div className="row align-items-end">
            <div className="col-xl-8 col-lg-6 col-md-7">
              <div className="it-testimonial-title-box">
                <span className="it-section-subtitle tertiary">
                  Testimonial
                </span>
                <h3 className="it-section-title">
                  What Our <br /> Customers Says?
                </h3>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-5">
              <div className="it-testimonial-arrow-box text-md-end">
                <button className="slider-prev-2">
                  <span>
                    <PrevArrowSVG />
                  </span>
                </button>
                <button className="slider-next-2">
                  <span>
                    <NextArrowSVG />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-testimonial-2-wrapper">
              <div className="swiper-container ">
                <Swiper
                  modules={[Navigation]}
                  {...sliderOption}
                  className="swiper-wrapper it-testimonial-2-active"
                >
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonialTwo
                      description={`“Standard dummy text ever since the unknown printer
                            took galley of scramble make a type specimen book
                            has the been industr”`}
                      avatarImage={avatarImg1}
                      authorName="Remedios Linared"
                      designation="Web designer"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonialTwo
                      description={`“Standard dummy text ever since the unknown printer
                            took galley of scramble make a type specimen book
                            has the been industr”`}
                      avatarImage={avatarImg1}
                      authorName="Jonathan Bell"
                      designation="Web designer"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonialTwo
                      description={`“Standard dummy text ever since the unknown printer
                            took galley of scramble make a type specimen book
                            has the been industr”`}
                      avatarImage={avatarImg1}
                      authorName="Morales Linared"
                      designation="Web designer"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTestimonialTwo
                      description={`“Standard dummy text ever since the unknown printer
                            took galley of scramble make a type specimen book
                            has the been industr”`}
                      avatarImage={avatarImg1}
                      authorName="Jonathan Bell"
                      designation="Web designer"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
